module.exports = __webpack_public_path__ + "img/1200px-Airbus_Logo_2017.7ffdd3bf.png";